/**
 * Auto-focus helpers for the public site-plan comparison visualizer.
 * Replicated from `super-picker/components/siteplan/compareSitePlanAutoFocus.ts`.
 */

type CompareSitePlanAnimationType =
  | 'linear'
  | 'easeOut'
  | 'easeInQuad'
  | 'easeOutQuad'
  | 'easeInOutQuad'
  | 'easeInCubic'
  | 'easeOutCubic'
  | 'easeInOutCubic'
  | 'easeInQuart'
  | 'easeOutQuart'
  | 'easeInOutQuart'
  | 'easeInQuint'
  | 'easeOutQuint'
  | 'easeInOutQuint';

export type CompareSitePlanZoomToElement = (
  node: string | HTMLElement,
  scale?: number,
  animationTime?: number,
  animationType?: CompareSitePlanAnimationType,
) => void;

export const getCompareSitePlanMarkerElementId = (unitKey: string): string => {
  const safeUnitKey = String(unitKey).replace(/[^A-Za-z0-9_-]/g, '-');
  return `compare-siteplan-marker-${safeUnitKey}`;
};

export const focusCompareSitePlanMarker = (
  markerElementId: string,
  zoomToElement: CompareSitePlanZoomToElement,
): boolean => {
  if (!document.getElementById(markerElementId)) {
    return false;
  }

  zoomToElement(markerElementId, 1, 250, 'easeOut');
  return true;
};
